import React from 'react';

import { Box } from '@mui/material';

import classes from './Stepper.module.scss';

type StepperProps = {
  stepsCount: number;
  activeStep: number;
};

const Stepper = ({ stepsCount, activeStep }: StepperProps) => {
  const getStepClasses = (value: number) => {
    const activeClass = value <= activeStep - 1 ? classes.active : null;

    return `${classes.step} ${activeClass}`;
  };

  return (
    <Box className={classes.container}>
      {[...new Array(stepsCount).keys()].map((value) => (
        <div className={getStepClasses(value)} key={value} />
      ))}
    </Box>
  );
};

export { Stepper };
